export default __webpack_public_path__ + "static/media/noImageWeb.3601bc20.png";